import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild ,Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SharedDataService } from './shared-data.service';

@Injectable()
export class AuthGuard implements CanActivate,CanActivateChild {

  constructor(private sharedDataService:SharedDataService, private router:Router){}

  canActivate(): boolean{

      if(this.sharedDataService.isUserAuthenticated()){
        return true;
      }else {
         this.router.navigate(['/']);
          return false;
      }

  }

  canActivateChild(): boolean{

    if(this.sharedDataService.isUserAuthenticated()){
      return true;
    }else {
      this.router.navigate(['/']);
      return false;
    }

  }


}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/auth.guard.ts